import { useState } from 'react';
import { PropTypes } from 'prop-types';
import {
  Dialog, TextField, Button, Stack, DialogTitle,
} from '@mui/material';
import useTranslations from '../data/useTranslations';
import TranslationField from './TranslationField';
import useAuthContext from '../auth/useAuthContext';
import useProjects from '../data/useProjects';

function TranslationDialog({ translation, open, handleClose }) {
  //  const { handleSubmit, control, reset, formState: { errors }, getValues, setValue } = useForm()
  const { user } = useAuthContext();
  const { projects, currentProject } = useProjects({ user });
  const { addTranslation, updateTranslation } = useTranslations({ user, currentProject });
  const [editMode] = useState(!!translation);
  const [key, setKey] = useState(translation?.trkey || '');
  const full = projects && projects.find((p) => p.project === currentProject);
  const languages = full && full.languages;
  const dcode = full && full.defaultLang?.code;
  const dname = full && full.defaultLang?.name;
  // Create a copy of the translation object
  const translationCopy = { ...translation };
  // Delete the property that matches the default language code
  delete translationCopy[dcode];

  const [srcText, setSrcText] = useState(translation?.[dcode] || '');
  const [destTexts, setDestTexts] = useState(translationCopy);
  console.debug(`Translation: ${JSON.stringify(translation)}`);
  // eslint-disable-next-line max-len
  // console.debug(`trkey: ${translation.trkey}, en: ${translation.en}, da: ${translation.da}, fr: ${translation.fr}, es: ${translation.es},`);
  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(currentProject);
    const translationData = {
      trkey: key,
      [dcode]: srcText,
      ...destTexts,
    };
    if (editMode) {
      updateTranslation(translationData);
    } else {
      addTranslation(translationData);
    }
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {`${editMode ? 'Edit' : 'Create New'} Translation Artefact`}
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <Stack>
          <TextField
            label='Key'
           // disabled={editMode}
            name='key'
            value={key}
            onChange={(e) => setKey(e.target.value)}
          />
          <TextField
            label={dname}
            name={dcode}
            value={srcText}
            onChange={(e) => setSrcText(e.target.value)}
          />
          {languages && languages.map((t) => (t.code !== dcode ? (
            <TranslationField
              key={t.code + currentProject.user}
              label={t.name}
              srcLang={dcode}
              destLang={t.code}
              srcText={srcText}
              value={destTexts[t.code]}
              onChange={(val) => setDestTexts((prev) => ({ ...prev, [t.code]: val }))}
            />
          ) : null))}

          <Button type='submit' variant='contained' color='primary'>
            Submit
          </Button>
        </Stack>
      </form>
    </Dialog>
  );
}

TranslationDialog.propTypes = {
  translation: PropTypes.arrayOf(PropTypes.shape({
    trkey: PropTypes.string,
    en: PropTypes.string,
    da: PropTypes.string,
    fr: PropTypes.string,
    es: PropTypes.string,
    ar: PropTypes.string,
    zh: PropTypes.string,
  })),
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

TranslationDialog.defaultProps = {
  open: false,
  handleClose: () => {},
  translation: [],
};

export default TranslationDialog;
